///? Default IMPORTS
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import React, { Component } from "react";

///? Service IMPORTS
import {
  coldchainDashboardThunk,
  coldchainManifestThunk,
  markDeliveredThunk,
  getRoleThunk,
  getRoleByIDThunk,
  assignRunnerThunk,
  handDeliveredThunk,
} from "../../../redux/ColdChainDashboardRedux/action";
import { getScannedPickerOrderDetailsThunk } from "../../../redux/NewPickerRedux/Action";

///? Component & Styling IMPORTS
import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "react-day-picker/moment";
import moment from "moment";
import "react-day-picker/lib/style.css";
import {
  Divider,
  Input,
  message,
  Spin,
  Table,
  Button,
  Tag,
  Select,
  Modal,
  Popconfirm,
  Alert,
} from "antd";
// import ToggleWarehouse from "../../../components/WarehouseToggle/toggleWarehouse";
import { FiSearch } from "react-icons/fi";
import { GrDocumentCsv } from "react-icons/gr";
import {
  ColdChainCSVModalWrapper,
  ColdChainDashboardTable,
  ColdChainDashboardWrapper,
  DashboardWrapperBox,
  RunnerDiv,
} from "./ColdChainDashboard.style";
import DashboardBox from "../../../components/DashboardBox/DashboardBox";
import { Base64func } from "../../../components/Base64Func/Base64func";
import { warehouseId } from "../../../constants";

///? Constants
message.config({
  maxCount: 1,
});

let disableSubmitBtnVar = false;

const { Option } = Select;

export class ColdChainDashboard extends Component {
  state = {
    from: undefined,
    to: undefined,
    loaderSearch: false,
    statLocal: null,
    warehouseId: warehouseId,
    // selectedTags: ["All"],
    isLoaded: false,
    checkerStats: null,
    currentBox: "Cold Chain Order",
    markDeliveredOrderId: null,
    markDeliveredModalShow: false,
    roleID: null,
    runnerData: null,
    selectedRunner: [],
    dispatchBlocker: [],
    isColdChainCSVModal: false,
    deliveryMode: null,
  };

  componentDidMount() {
    window.onbeforeunload = function () {
      if (disableSubmitBtnVar) {
        return "Data will be lost if you leave the page, are you sure?";
      }
    };
    // let { warehouseId, selectedTags } = this.state;
    // if (this.props.userDto) {
    //   if (this.props.userType) {
    //     warehouseId = [0];
    //     selectedTags = ["All"];
    //   } else {
    //     warehouseId = [this.props.userDto.warehouseIdList[0]];
    //     selectedTags = this.props.warehouseList[warehouseId]["warehouseName"];
    //   }
    // }

    this.setState(
      {
        // warehouseId,
        // selectedTags,
        isLoaded: true,
        from: this.getStartDate(new Date()),
        to: new Date(),
      },
      () => {
        // this.getCheckerData();
      }
    );
  }

  getStartDate = (date) => {
    date.setDate(date.getDate() - 2);
    return date;
  };

  // handleWareHouseChange = (data) => {
  //   this.setState(
  //     {
  //       selectedTags: data.selectedTags,
  //       warehouseId: [data.warehouseId],
  //       isLoaded: false,
  //     },
  //     () => {
  //       this.getCheckerData();
  //     }
  //   );
  // };

  handleFromChange = (from) => {
    this.setState({ from });
  };
  handleToChange = (to) => {
    this.setState({ to }, this.showFromMonth);
  };
  showFromMonth = () => {
    const { from, to } = this.state;
    if (!from) {
      return;
    }
    if (moment(to).diff(moment(from), "months") < 2) {
      this.to.getDayPicker().showMonth(from);
    }
  };
  DateFormatter = (param) => {
    let result =
      this.state[param].getFullYear() +
      "-" +
      (this.state[param].getMonth() + 1) +
      "-" +
      this.state[param].getDate();
    return result;
  };

  getCheckerData = () => {
    disableSubmitBtnVar = true;
    message.loading("Loading Data..., Please Wait!", 0);
    this.setState({ isLoaded: false });
    let { from, to } = this.state;
    let { userDto } = this.props;
    // let { warehouseId } = this.state;
    if (from && to) {
      this.setState({ loaderSearch: true });
      let fromRefined = this.DateFormatter("from");
      let toRefined = this.DateFormatter("to");
      let propsData = {
        access_token: this.props.access_token,
        fromDate: fromRefined + " 00:00:01",
        toDate: toRefined + " 23:59:59",
        history: this.props.history,
        isPickingPending:
          this.state.currentBox === "Picking Pending" ? true : false,
        isPendingForDispatch:
          this.state.currentBox === "Pending for Dispatched" ? true : false,
        isDispatched: this.state.currentBox === "Dispatched" ? true : false,
        isColdChain:
          this.state.currentBox === "Cold Chain Order" ? true : false,
      };

      let data = [warehouseId];

      setTimeout(() => {
        if (!this.state.isLoaded) {
          message.loading(
            "This page is taking longer to load than usual, please wait!",
            0
          );
        }
      }, 5000);

      this.props.coldchainDashboardThunk(propsData, data).then(() => {
        disableSubmitBtnVar = false;
        message.destroy();
        if (this.props?.stat?.coldChainDashboardError) {
          message.error(
            this.props?.stat?.coldChainDashboardError
              ? this.props?.stat?.coldChainDashboardError
              : "Something went wrong"
          );
          this.setState({
            loaderSearch: false,
            isLoaded: true,
            statLocal: null,
          });
        } else {
          message.success("Data successfully loaded");

          this.setState(
            {
              loaderSearch: false,
              statLocal: this.props?.stat?.coldChainDashboardData,
              isLoaded: true,
            },
            () => {
              let tempArray = [];

              let { statLocal } = this.state;

              statLocal.stats.map((i) => {
                tempArray.push([
                  {
                    name: "Cold Chain Order",
                    count: i.coldChainOrder,
                    type: "cold",
                  },
                  {
                    name: "Picking Pending",
                    count: i.pickingPending,
                    type: "damage",
                  },
                  {
                    name: "Picked",
                    count: i.picked,
                    type: "pick",
                  },
                  {
                    name: "Dispatched",
                    count: i.dispatched,
                    type: "dispatch",
                  },
                  {
                    name: "Pending for Dispatched",
                    count: i.pendingForDispatch,
                    type: "dispatch",
                  },
                  {
                    name: "Missing Med",
                    count: i.missingMedicine,
                    type: "missingMed",
                  },
                ]);
              });

              this.setState({ checkerStats: tempArray });
            }
          );
        }
      });
    } else {
      message.warn("Please select a date range");
      this.setState({ isLoaded: true, loaderSearch: false });
    }
  };

  dashboradBoxClick = (value) => {
    this.setState({ currentBox: `${value}` }, () => {
      this.getCheckerData();

      if (this.state.currentBox === "Pending for Dispatched") {
        this.getRunnerFunc();
      }
    });
  };

  getRunnerFunc = () => {
    let data = {
      access_token: this.props.access_token,
      history: this.props.history,
    };

    this.props.getRoleThunk(data).then(() => {
      if (this.props.stat.getRoleError) {
        message.error(this.props.stat.getRoleError);
      } else {
        this.props.stat.getRoleData?.map((i) => {
          if (i.roleName === "RUNNER_ROLE") {
            this.setState({ roleID: i.roleId }, () => {
              let roleIDData = {
                access_token: this.props.access_token,
                history: this.props.history,
                roleId: this.state.roleID,
              };
              this.props.getRoleByIDThunk(roleIDData).then(() => {
                if (this.props.stat.getRoleIDError) {
                  message.error(this.props.stat.getRoleIDError);
                } else {
                  let selectOption = [];
                  this.props.stat.getRoleIDData?.map((i) => {
                    if (i.active) {
                      selectOption.push({
                        value: i.userId,
                        option: i.firstName + " " + i.lastName,
                      });
                    }
                  });
                  this.setState({ runnerData: selectOption });
                }
              });
            });
          }
        });
      }
    });
  };

  //?Cold chain CSV Functions here
  coldChainCSVFunc = () => {
    let data = {
      access_token: this.props.access_token,
      history: this.props.history,
      warehouseId: this.state.warehouseId,
    };

    this.props.coldchainManifestThunk(data).then(() => {
      if (this.props.stat?.coldChainCSVError) {
        message.error(this.props.stat.coldChainCSVError);
      } else {
        this.setState({
          coldChainCSVData: this.props.stat?.coldChainCSVData,
          isColdChainCSVModal: true,
        });
      }
    });
  };

  downloadCSVFunc = () => {
    window.open(`${this.state.coldChainCSVData.manifestListUrl}`, "_blank");
  };

  //? Pending Picking rowclick func
  pickingPendingRedirect = (record) => {
    let data = {
      orderId: record.orderId,
      warehouseId: this.state.warehouseId,
      access_token: this.props.access_token,
      history: this.props.history,
    };

    this.props.getScannedPickerOrderDetailsThunk(data).then(() => {
      if (this.props.newPickerDetails.newScannedPickerOrderError) {
        message.error(this.props.newPickerDetails.newScannedPickerOrderError);
      } else {
        setTimeout(() => {
          message.destroy();
          this.props.history.push(
            `/picker-order-process/orderId=${Base64func(
              record.orderId,
              "encode"
            )}`
          );
        }, 1000);
      }
    });
  };

  //? Coldchain row click func
  coldChainRedirect = (record) => {
    setTimeout(() => {
      message.destroy();
      this.props.history.push(
        `/coldChainMark/orderId=${Base64func(record.orderId, "encode")}`
      );
    }, 1000);
  };

  //? Mark delivered function
  markDeliveredFunc = () => {
    message.loading(
      `Marking Order #${this.state.markDeliveredOrderId} as Delivered...`,
      0
    );
    let data = {
      orderId: this.state.markDeliveredOrderId,
      access_token: this.props.access_token,
      history: this.props.history,
    };

    this.props.markDeliveredThunk(data).then(() => {
      if (this.props.stat.markDeliveredError) {
        message.error(this.props.stat.markDeliveredError);
        this.setState({ markDeliveredModalShow: false });
      } else {
        message.success(this.props.stat.markDeliveredData?.OK);
        this.setState({ markDeliveredModalShow: false });

        this.getCheckerData();
      }
    });
  };

  //? Mark dispatched function
  dispatchedFunc = (orderId, salesOrderId, packageId) => {
    let data = {
      access_token: this.props.access_token,
      history: this.props.history,
      orderId: orderId,
      salesOrderId: salesOrderId,
      packageId: packageId,
    };

    this.props.handDeliveredThunk(data).then(() => {
      if (this.props.stat.markDeliveredError) {
        message.error(this.props.stat.markDeliveredError);
      } else {
        message.success(this.props.stat.markDeliveredData);
        this.getCheckerData();
      }
    });
  };

  //? Assign Runner Function
  assignRunnerFunc = (orderId) => {
    let currentRunnerID = null;
    this.state.selectedRunner.map((i) => {
      if (i.orderId === orderId) {
        currentRunnerID = i.runnerId;
      }
    });

    if (currentRunnerID) {
      let data = {
        orderId: orderId,
        access_token: this.props.access_token,
        history: this.props.history,
        runnerId: currentRunnerID,
      };

      this.props.assignRunnerThunk(data).then(() => {
        if (this.props.stat.assignRunnerError) {
          message.error(this.props.stat.assignRunnerError);
        } else {
          message.success(this.props.stat.assignRunnerData);

          let currentDispatchBlocker = [...this.state.dispatchBlocker];

          currentDispatchBlocker.push(orderId);

          this.setState({ dispatchBlocker: currentDispatchBlocker }, () => {
            this.getCheckerData();
          });
        }
      });
    } else {
      message.warning("Please select runner first");
    }
  };

  ////? Table search filter
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          //  icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <FiSearch style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    //  render: (text) => (
    //    <Highlighter
    //      highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
    //      searchWords={[this.state.searchText]}
    //      autoEscape
    //      textToHighlight={text.toString()}
    //    />
    //  ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  // - Ends //

  render() {
    const { from, to } = this.state;
    const modifiers = { start: from, end: to };
    const ColdChainCSVColumn = [
      {
        title: "Date",
        dataIndex: "date",
        width: 100,
        key: "date",
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Order ID",
        dataIndex: "orderId",
        key: "orderId",
        ...this.getColumnSearchProps("orderId"),
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Customer Name",
        dataIndex: "customerName",
        key: "customerName",
        ...this.getColumnSearchProps("customerName"),
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Mobile No.",
        dataIndex: "cutomerMobile",
        key: "cutomerMobile",
        ...this.getColumnSearchProps("cutomerMobile"),
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Alternate Mobile No.",
        dataIndex: "cutomerAlternateMobile",
        key: "cutomerAlternateMobile",
        ...this.getColumnSearchProps("cutomerAlternateMobile"),
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Address",
        dataIndex: "address",
        key: "address",
        // ...this.getColumnSearchProps("address"),
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Runner Name",
        dataIndex: "runnerName",
        key: "runnerName",
        ...this.getColumnSearchProps("runnerName"),
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Amount",
        dataIndex: "amount",
        key: "amount",
        sorter: (a, b) => a.amount - b.amount,
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
    ];
    const PickingPendingColumns = [
      {
        title: "Order ID",
        dataIndex: "orderId",
        key: "orderId",
        ...this.getColumnSearchProps("orderId"),
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Pending Since",
        dataIndex: "pendingSince",
        key: "pendingSince",
        sorter: (a, b) => a.pendingSince - b.pendingSince,
        render: (text) => {
          return {
            children: (
              <span>
                {" "}
                {text > 12 ? (
                  <Tag color="red">{text} Hrs</Tag>
                ) : (
                  <Tag color="green">{text} Hrs</Tag>
                )}
              </span>
            ),
          };
        },
      },
    ];

    const DispatchedColumns = [
      {
        title: "Order ID",
        dataIndex: "orderId",
        key: "orderId",
        ...this.getColumnSearchProps("orderId"),
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        sorter: (a, b) => a.status - b.status,
        render: (text) => {
          return {
            children: <span>Picked-Dispatch Pending</span>,
          };
        },
      },
      {
        title: "Picked By",
        dataIndex: "pickedBy",
        key: "pickedBy",
        ...this.getColumnSearchProps("pickedBy"),
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Assigned Runner",
        dataIndex: "assignedRunner",
        key: "assignedRunner",
        ...this.getColumnSearchProps("assignedRunner"),
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "",
        dataIndex: "orderId",
        key: "orderId",
        render: (text) => {
          return {
            children: (
              <button
                className="bbtn"
                onClick={() => {
                  this.setState({
                    markDeliveredOrderId: text,
                    markDeliveredModalShow: true,
                  });
                }}
              >
                Marked As Delivered
              </button>
            ),
          };
        },
      },
    ];

    const PendingDispatchedColumns = [
      {
        title: "Order ID",
        dataIndex: "orderId",
        key: "orderId",
        ...this.getColumnSearchProps("orderId"),
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        sorter: (a, b) => a.status - b.status,
        render: (text) => {
          return {
            children: <span>Picked-Dispatch Pending</span>,
          };
        },
      },
      {
        title: "Picked By",
        dataIndex: "pickedBy",
        key: "pickedBy",
        ...this.getColumnSearchProps("pickedBy"),
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Dispatch Pending Since",
        dataIndex: "pendingSince",
        key: "pendingSince",
        sorter: (a, b) => a.pendingSince - b.pendingSince,
        render: (text) => {
          return {
            children: (
              <span>
                {" "}
                {text > 12 ? (
                  <Tag color="red">{text} Hrs</Tag>
                ) : (
                  <Tag color="green">{text} Hrs</Tag>
                )}
              </span>
            ),
          };
        },
      },
      {
        title: "Pincode",
        dataIndex: "pincode",
        key: "pincode",
        ...this.getColumnSearchProps("pincode"),
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "",
        dataIndex: "paymentDone",
        key: "paymentDone",
        sorter: (a, b) => a.status - b.status,
        render: (text, record) => {
          return {
            children: (
              <span>
                {" "}
                {!text ? (
                  <Tag color="yellow">Payment Pending</Tag>
                ) : (
                  <Popconfirm
                    title="Mark this order dispatched?"
                    onConfirm={() => {
                      this.dispatchedFunc(
                        record.orderId,
                        record.salesOrderId,
                        record.packageId
                      );
                    }}
                    disabled={
                      !this.state.dispatchBlocker.includes(record.orderId) &&
                      !record.runnerId
                    }
                    // onCancel={cancel}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Tag
                      style={{ cursor: "pointer" }}
                      color={
                        !this.state.dispatchBlocker.includes(record.orderId) &&
                        !record.runnerId
                          ? "default"
                          : `blue`
                      }
                    >
                      Dispatch
                    </Tag>
                  </Popconfirm>
                )}
              </span>
            ),
          };
        },
      },
      {
        title: "Select Runner Name Dropdown",
        render: (text, record) => {
          return {
            children: (
              <RunnerDiv>
                <Select
                  showSearch
                  placeholder="Select a person"
                  optionFilterProp="children"
                  defaultValue={record.runnerId}
                  style={{ width: "100%" }}
                  disabled={
                    record.deliveryMode === 186 ? !record.paymentDone : true
                  }
                  size="large"
                  onChange={(value) => {
                    let runnerObj = [...this.state.selectedRunner];

                    if (value) {
                      runnerObj.push({
                        orderId: record.orderId,
                        runnerId: value,
                      });
                    }

                    this.setState({
                      selectedRunner: runnerObj,
                    });
                  }}
                >
                  {this.state.runnerData?.map((i, l) => (
                    <Option key={l} value={i.value}>
                      {i.option}
                    </Option>
                  ))}
                </Select>

                <button
                  className="bbtn"
                  disabled={
                    !this.state.selectedRunner ||
                    !this.state.selectedRunner?.some(
                      (i) => i.orderId === record.orderId
                    )
                  }
                  onClick={() => this.assignRunnerFunc(record.orderId)}
                >
                  Submit
                </button>
              </RunnerDiv>
            ),
          };
        },
      },
    ];
    return (
      <>
        <ColdChainDashboardWrapper>
          <div className="DateSelect">
            <DayPickerInput
              value={from}
              placeholder="From"
              format="DD/MM/YYYY"
              formatDate={formatDate}
              parseDate={parseDate}
              dayPickerProps={{
                selectedDays: [from, { from, to }],
                disabledDays: { after: to },
                toMonth: to,
                modifiers,
                numberOfMonths: 2,
                onDayClick: () => this.to.getInput().focus(),
              }}
              onDayChange={this.handleFromChange}
            />

            <DayPickerInput
              ref={(el) => (this.to = el)}
              value={to}
              placeholder="To"
              format="DD/MM/YYYY"
              formatDate={formatDate}
              parseDate={parseDate}
              dayPickerProps={{
                selectedDays: [from, { from, to }],
                disabledDays: { before: from },
                modifiers,
                month: from,
                fromMonth: from,
                numberOfMonths: 2,
              }}
              onDayChange={this.handleToChange}
            />
            <button
              className="bbtn"
              onClick={() => {
                this.getCheckerData();
              }}
              // disabled={!this.state.from || !this.state.to}
              disabled={!this.state.isLoaded}
            >
              Search
            </button>
          </div>

          <button
            className="bbtn"
            style={{ width: "max-content" }}
            disabled={!this.state.statLocal || this.state.isColdChainCSVModal}
            onClick={this.coldChainCSVFunc}
          >
            Export CSV <GrDocumentCsv />
          </button>

          {/* {this.props.userType ? (
            <ToggleWarehouse
              handleWareHouseChange={(data) => this.handleWareHouseChange(data)}
              selectedTags={this.state.selectedTags}
              warehouseId={this.state.warehouseId}
              userDto={this.props.userDto}
              warehouseList={this.props.warehouseList}
              isLoaded={this.state.isLoaded}
            />
          ) : (
            ""
          )} */}
        </ColdChainDashboardWrapper>

        {this.state.statLocal && (
          <Spin spinning={!this.state.isLoaded}>
            <Divider>Cold Chain Stats</Divider>

            <DashboardWrapperBox>
              {this.state.checkerStats &&
                this.state.checkerStats[0].map((i, p) => (
                  <DashboardBox
                    name={i.name}
                    subName={i.subName}
                    count={i.count}
                    totalCount={i.totalCount}
                    type={i.type}
                    key={p}
                    onClick={this.dashboradBoxClick}
                    activeBox={this.state.currentBox}
                    clickable={
                      i.name !== "Total Orders" &&
                      i.name !== "Admin Picker Available" &&
                      i.name !== "Picked" &&
                      i.name !== "Missing Med"
                        ? true
                        : false
                    }
                  />
                ))}
            </DashboardWrapperBox>

            <Divider style={{ margin: "2.5em  0" }}>
              Cold Chain Dashboard Stats
            </Divider>

            <ColdChainDashboardTable>
              <Table
                dataSource={this.state.statLocal.dashBoardStats}
                columns={
                  this.state.currentBox === "Picking Pending"
                    ? PickingPendingColumns
                    : this.state.currentBox === "Dispatched"
                    ? DispatchedColumns
                    : this.state.currentBox === "Pending for Dispatched"
                    ? PendingDispatchedColumns
                    : this.state.currentBox === "Cold Chain Order"
                    ? PickingPendingColumns
                    : null
                }
                loading={!this.state.isLoaded}
                pagination={
                  this.state.statLocal.dashBoardStats.length > 10 ? true : false
                }
                onRow={(record, rowIndex) => {
                  if (this.state.currentBox === "Picking Pending") {
                    return {
                      onClick: (event) => {
                        message.loading("Loading...", 0);
                        this.pickingPendingRedirect(record);
                      },
                    };
                  } else if (this.state.currentBox === "Cold Chain Order") {
                    return {
                      onClick: (event) => {
                        message.loading("Loading...", 0);
                        this.coldChainRedirect(record);
                      },
                    };
                  } else {
                    return null;
                  }
                }}
                bordered
                scroll={{ x: 700 }}
              />

              <Modal
                title={`Mark OrderID : ${this.state.markDeliveredOrderId} as Delivered ?`}
                visible={this.state.markDeliveredModalShow}
                // centered
                onOk={this.markDeliveredFunc}
                onCancel={() =>
                  this.setState({ markDeliveredModalShow: false })
                }
              />

              <Modal
                title="Cold-Chain CSV"
                visible={this.state.isColdChainCSVModal}
                footer={null}
                width={1000}
                // centered
                onOk={this.markDeliveredFunc}
                onCancel={() => this.setState({ isColdChainCSVModal: false })}
              >
                <ColdChainCSVModalWrapper>
                  <Table
                    dataSource={this.state.coldChainCSVData?.manifestList}
                    columns={ColdChainCSVColumn}
                    loading={!this.state.isLoaded}
                    pagination={
                      this.state.coldChainCSVData?.manifestList?.length > 10
                        ? true
                        : false
                    }
                    bordered
                    scroll={{ x: 700 }}
                  />

                  <button
                    className="bbtn"
                    onClick={this.downloadCSVFunc}
                    disabled={!this.state.coldChainCSVData?.manifestListUrl}
                  >
                    Export CSV <GrDocumentCsv />
                  </button>
                </ColdChainCSVModalWrapper>
              </Modal>
            </ColdChainDashboardTable>
          </Spin>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  stat: state.coldChainDashReducer,
  userDto: state.authReducer?.AuthData?.userDTO,
  userType: state.authReducer?.userType,
  warehouseList: state.authReducer?.AuthData?.warehouseList,
  newPickerDetails: state.newPickerOrderReducer,
});

const mapDispatchToProps = {
  coldchainDashboardThunk,
  coldchainManifestThunk,
  getScannedPickerOrderDetailsThunk,
  markDeliveredThunk,
  getRoleThunk,
  getRoleByIDThunk,
  assignRunnerThunk,
  handDeliveredThunk,
};

export default connect(mapStateToProps, mapDispatchToProps)(ColdChainDashboard);
